enum TeamStatus {
  ACTIVE = 'ACTIVE', INACTIVE = 'INACTIVE',
}

export default TeamStatus;
